<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Está e o menu de mentorias, aqui você pode solicitar mentorias de
              acordo com suas necessidades e receber o retorno da empresa em
              relação a sua solicitação. Para realizar a solicitação basta
              preencher as informações abaixo da melhor forma possível e assim
              que possível você receberá uma resposta da empresa.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div>
            <card shadow>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">Solicitar mentoria</h3>
                  </div>
                </div>
              </div>
              <template>
                <form role="form" class="vld-parent" ref="support_form">
                  <div class="row ml-lg-2 pb-3">
                    <div class="col-lg-12">
                      <label class="form-control-label"
                        >Qual o tipo da mentoria
                      </label>
                      <select class="form-control" v-model="model.type">
                        <option selected disabled value="">
                          Selecione um tema
                        </option>
                        <option :value="'technical'">Técnica</option>
                        <option :value="'business'">Negócio</option>
                      </select>
                    </div>
                  </div>

                  <div class="row ml-lg-2">
                    <div class="col-lg-6">
                      <base-input
                        label="Tema"
                        placeholder="Informe o tema da mentoria"
                        v-model="model.subject"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="O que você está precisando"
                        placeholder="Descreve o que você precisa"
                        v-model="model.need"
                      />
                    </div>
                  </div>
                  <div class="row ml-lg-2">
                    <div class="col-lg-6">
                      <base-input
                        label="Quais informações você achou sobre o tema?"
                        placeholder="Escreva as informações que já encontrou sobre o tema"
                        v-model="model.known"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Quais são as principais perguntas a serem respondidas?"
                        placeholder="Escreva as principais perguntas a serem respondidas"
                        v-model="model.questions"
                      />
                    </div>
                  </div>
                  <hr class="mt-2 mb-4" />
                  <div class="row ml-lg-2">
                    <div class="col-lg-12">
                      <base-input label="Informações adicionais">
                        <textarea
                          rows="2"
                          class="form-control"
                          placeholder="Forneça mais informações sobre a mentoria"
                          v-model="model.description"
                        />
                      </base-input>
                    </div>
                  </div>

                  <div class="row ml-lg-2">
                    <div class="col-12">
                      <base-alert
                        type="danger"
                        class="text-center mt-4 mb-0"
                        v-if="error"
                        ><i class="fas fa-exclamation-circle mr-1"></i>
                        {{ error }}</base-alert
                      >
                      <base-alert
                        v-if="success"
                        type="success"
                        class="text-center mt-4 mb-0"
                        ><i class="fas fa-thumbs-up mr-1"></i>
                        {{ success }}</base-alert
                      >
                    </div>
                    <div class="col-12 mt-4 text-right">
                      <base-button
                        type="primary"
                        :custom="true"
                        @click="handleSubmit"
                        >Enviar solicitação</base-button
                      >
                    </div>
                  </div>
                </form>
              </template>
            </card>
            <div>
              <div class="vld-parent" ref="mentorings_container">
                <div class="row">
                  <div class="col-12">
                    <hr class="my-4" />
                  </div>
                </div>
                <div class="row" v-if="!loaded">
                  <div class="col-12 text-center">
                    <base-button
                      type="link"
                      :custom="true"
                      @click="handleLoadAllMentorings"
                      >Carregar histórico de mentorias</base-button
                    >
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-12 text-center" v-if="!mentorings.length">
                    <badge type="primary"
                      >Não há mesagens enviadas no histórico</badge
                    >
                  </div>
                  <div v-else class="col-12">
                    <div class="row">
                      <div
                        class="col-12"
                        v-for="mentoring in mentorings"
                        :key="'mentoring' + mentoring.id"
                      >
                        <div class="card mb-3">
                          <div class="card-body pt-3 pb-2">
                            <div class="row">
                              <div
                                class="
                                  col-12
                                  my-3
                                  sh-container-read-only
                                  text-sm
                                "
                              >
                                <div class="col-12">
                                  <i
                                    class="fas fa-caret-right text-sm mr-1"
                                  ></i>
                                  <b class="font-weight-bold"
                                    >Qual o tipo da mentoria:</b
                                  >
                                  {{
                                    mentoring.type === "technical"
                                      ? "Técnica"
                                      : "Negócio"
                                  }}
                                </div>
                                <div class="col-12">
                                  <i
                                    class="fas fa-caret-right text-sm mr-1"
                                  ></i>
                                  <b class="font-weight-bold">Tema:</b>
                                  {{ mentoring.subject }}
                                </div>
                                <div class="col-12">
                                  <i
                                    class="fas fa-caret-right text-sm mr-1"
                                  ></i>
                                  <b class="font-weight-bold"
                                    >O que você está precisando:</b
                                  >
                                  {{ mentoring.need }}
                                </div>
                                <div class="col-12">
                                  <i
                                    class="fas fa-caret-right text-sm mr-1"
                                  ></i>
                                  <b class="font-weight-bold"
                                    >Quais informações você achou sobre o
                                    tema?</b
                                  >
                                  {{ mentoring.known }}
                                </div>
                                <div class="col-12">
                                  <i
                                    class="fas fa-caret-right text-sm mr-1"
                                  ></i>
                                  <b class="font-weight-bold"
                                    >Quais são as principais perguntas a serem
                                    respondidas?</b
                                  >
                                  {{ mentoring.questions }}
                                </div>
                                <div class="col-12">
                                  <i
                                    class="fas fa-caret-right text-sm mr-1"
                                  ></i>
                                  <b class="font-weight-bold"
                                    >Informações adicionais:</b
                                  >
                                  <div class="border rounded">
                                    <quill-editor
                                      v-model="mentoring.description"
                                      :options="editorReadOnly"
                                      disabled="disabled"
                                    ></quill-editor>
                                    <div class="mt-2">
                                      <div
                                        class="
                                          text-muted text-sm text-right
                                          mr-1
                                        "
                                      >
                                        Enviado em:
                                        {{
                                          formatTimestamp(mentoring.created_at)
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <h3 class="h4 text-center my-2">
                                    <i
                                      class="fas fa-comments text-green mr-1"
                                    ></i>
                                    Respostas recebidas
                                  </h3>
                                  <div v-if="!mentoring.responses.length">
                                    <p class="description text-center mb-0">
                                      Nenhuma resposta recebida até o momento
                                    </p>
                                  </div>
                                  <div v-else>
                                    <div
                                      class="border rounded mb-2"
                                      v-for="response in mentoring.responses"
                                      :key="`response_${response.id}`"
                                    >
                                      <p class="description p-2">
                                        {{ response.content }}
                                      </p>
                                      <div class="mt-2">
                                        <div
                                          class="
                                            text-muted text-sm text-right
                                            mr-1
                                          "
                                        >
                                          <i class="far fa-clock mr-1" />
                                          {{
                                            formatTimestamp(response.created_at)
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="text-muted text-right">
                          <b>{{ mentorings.length }}</b> mentorias solicitadas
                          ao total
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api.js";

export default {
  name: "suporte_collaborator",
  components: {
    quillEditor
  },
  data() {
    return {
      model: {
        type: ""
      },
      mentorings: [],
      loaded: false,
      success: "",
      error: "",
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble"
      }
    };
  },
  methods: {
    async handleLoadAllMentorings() {
      this.loaded = false;
      const loader = this.$loading.show({
        container: this.$refs.mentorings_container,
        width: 90,
        height: 90
      });
      try {
        const { data } = await api.get("collaborator/mentorings");
        this.mentorings = data;
        this.loaded = true;
        loader.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as mentorias");
      }
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.error = this.success = "";
      const data = this.model;
      if (!data.subject) {
        this.error = "Você deve informar o tema da mentoria.";
        return;
      }
      const loader = this.$loading.show({
        container: this.$refs.support_form,
        width: 160,
        height: 160
      });
      try {
        await api.post("collaborator/mentorings", data);
        this.model.category = this.model.subject = this.model.description = "";
        this.success =
          "Soliocitação enviada com sucesso. Fique tranquilo, se necessário, você será contatado! :)";
        this.$toasted.show("Mensagem enviada com sucesso");
      } catch (e) {
        const genericError = "Não foi possível salvar as informações.";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data.error
            ? e.response.data.error
            : e.response.data.errors;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.error = hasErrorResponseData ? customError : genericError;
        this.$toasted.error(genericError);
      } finally {
        loader.hide();
      }
    }
  }
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.link {
  color: #5e72e4;
}
.link:hover {
  color: #233dd2;
}
</style>
